import React, { ComponentProps, FC } from 'react';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import { useLocation, useHistory } from 'react-router-dom';
import { Brand } from '@/apis/core';
import { capitalizeFirstLetter } from '../../../../../utils';
import { getEntityType } from '../../utils';

interface Props {
  brand: Brand;
}

const Cell: FC<ComponentProps<typeof TableCell> & { hidden?: boolean }> = ({
  children,
  hidden,
  ...props
}) => (hidden ? null : <TableCell {...props}>{children}</TableCell>);

const BrandListingRow: FC<Props> = (props: Props) => {
  const { brand } = props;
  const history = useHistory();
  const location = useLocation();
  return (
    <TableRow
      className="link"
      data-testid="brandingListingRow"
      onClick={() =>
        history.push({
          pathname: `/brands/${brand.uid}`,
          state: {
            goBackPage: `${location.pathname}${
              location.search ? location.search : ''
            }`,
          },
        })
      }
    >
      <Cell
        align="left"
        style={{ minWidth: 90 }}
        data-testid="brandingListingRowUid"
      >
        <span>{brand.uid}</span>
      </Cell>
      <Cell
        align="left"
        style={{ minWidth: 140, maxWidth: 220 }}
        data-testid="brandingListingRowCompanyName"
      >
        {brand.companyName
          ? brand.companyName
          : brand.entityType === 'SOLE_PROPRIETOR'
          ? 'Redacted due to PII'
          : 'N/A'}
      </Cell>
      <Cell
        align="left"
        style={{ minWidth: 140, maxWidth: 220 }}
        data-testid="brandingListingRowDisplayName"
      >
        {brand.displayName
          ? brand.displayName
          : brand.entityType === 'SOLE_PROPRIETOR'
          ? 'Redacted due to PII'
          : 'N/A'}
      </Cell>
      <Cell
        align="left"
        style={{ minWidth: 140, maxWidth: 220 }}
        data-testid="brandingListingRowCspDisplayName"
      >
        {brand.csp.displayName ? brand.csp.displayName : 'N/A'}
      </Cell>
      <Cell
        align="left"
        style={{ minWidth: 140 }}
        data-testid="brandingListingRowEntityType"
      >
        {getEntityType(brand.entityType)}
      </Cell>
      <Cell
        align="left"
        style={{ minWidth: 140, maxWidth: 220 }}
        data-testid="brandingListingRowUniversalEin"
      >
        {brand.universalEin ? brand.universalEin : 'N/A'}
      </Cell>
      <Cell
        align="left"
        style={{ minWidth: 140, maxWidth: 220 }}
        data-testid="brandingListingRowStatus"
      >
        {brand.status ? capitalizeFirstLetter(brand.status) : 'N/A'}
      </Cell>
      <Cell align="left" data-testid="brandingListingRowActiveCampaignCount">
        {brand.activeCampaignCount != null ? brand.activeCampaignCount : '0'}
      </Cell>
    </TableRow>
  );
};

export default BrandListingRow;
